import { gql } from "apollo-boost";



export const UPDATE_EXCHANGERATE = gql`
mutation UpdateExchangeRate($where: ExchangeRateWhereInputOne!, $data: ExchangeRateInput) {
    updateExchangeRate(where: $where, data: $data) {
      id
    }
  }
`